<div [formGroup]="parentForm" id="extra-prompts-container">
  <mm-radio-control *ngIf="!showBundledPrompts" [parentForm]="extraPromptsGroup" [radioModel]="useStandingAuthModel" class="big-bottom-spacer"
    data-testid="useStandingAuthControl">
  </mm-radio-control>
  <mm-radio-control *ngIf="showBundledPrompts" [parentForm]="extraPromptsGroup" [radioModel]="bsloaModel" class="big-bottom-spacer">
  </mm-radio-control>
  <div id="bundled-radio-container" *ngIf="useBundledPromptsSelected">
    <mm-radio-control [parentForm]="extraPromptsGroup" [radioModel]="useBundledModel" class="big-bottom-spacer" data-testid="bundled-standingAuth-prompts">
    </mm-radio-control>
    <mm-tooltip [position]="'right'" [containsLink]="false" id="bundled-total-dist-radio-tooltip" data-testid="bundled-total-dist-radio-tooltip">
      <tooltip-content>
        <div>{{totalDistributionTooltip}}</div>
      </tooltip-content>
      <tooltip-trigger-element>
        <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
      </tooltip-trigger-element>
    </mm-tooltip>
  </div>
  <ng-container *ngIf="showBundledStandingAuthSelection">
    <mm-standing-authorization-card-container
      *ngIf="enableUseSloaContainer; else legacyBundledStandingAuthControl"
      [label]="'Select standing authorization'"
      [authorizationCount]="bundledStandingAuthCards.length"
      [cards]="bundledStandingAuthCards"
      (cardSelected)="onStandingAuthCardSelected($event)">
    </mm-standing-authorization-card-container>
    <ng-template #legacyBundledStandingAuthControl>
      <mm-card-component [parentForm]="extraPromptsGroup" [cardModel]="bundledCardModel"
        data-testid="bundledStandingAuthSelectionControl">
      </mm-card-component>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="showStandingAuthSelection">
    <mm-standing-authorization-card-container
      *ngIf="enableUseSloaContainer; else legacyStandingAuthControl"
      [label]="'Select standing authorization'"
      [authorizationCount]="standingAuthCards.length"
      [cards]="standingAuthCards"
      (cardSelected)="onStandingAuthCardSelected($event)">
    </mm-standing-authorization-card-container>
    <ng-template #legacyStandingAuthControl>
      <mm-card-component [parentForm]="extraPromptsGroup" [cardModel]="standingAuthCardModel"
        data-testid="standingAuthSelectionControl">
      </mm-card-component>
    </ng-template>
  </ng-container>
  <mm-banners *ngIf="(showStandingAuthSelection || showBundledStandingAuthSelection)&& standingInstructions?.length === 0"
    [bannerText]="['There are no standing authorizations on this account.']" [type]="'error'" class="big-bottom-spacer" data-testid="standing-auth-error-banner">
  </mm-banners>
  <div *ngIf="showFrequencySelection" id="tooltip-radio-container" data-testid="tooltip-radio-container">
    <mm-radio-control  [parentForm]="extraPromptsGroup"
      [radioModel]="frequencySelectorModel" class="big-bottom-spacer" data-testid="frequencyControl">
    </mm-radio-control>
    <mm-tooltip [position]="'right'" [containsLink]="false" id="total-dist-radio-tooltip" data-testid="total-dist-radio-tooltip">
      <tooltip-content>
        <div>{{totalDistributionTooltip}}</div>
      </tooltip-content>
      <tooltip-trigger-element>
        <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
      </tooltip-trigger-element>
    </mm-tooltip>
  </div>
  <mm-banners *ngIf="isOneTimeTotalDist"
    [bannerText]=[totalDistributionConstants.totalDistributionWarningTextChecks] [type]="'warning'" class="big-bottom-spacer">
  </mm-banners>
  <mm-radio-control *ngIf="isOneTimeTotalDist" [parentForm]="extraPromptsGroup" [radioModel]="closeAccountModel"
    class="big-bottom-spacer">
  </mm-radio-control>
  <mm-reports-statements-section *ngIf="isOneTimeTotalDist" class="big-bottom-spacer"
  [parentForm]="extraPromptsGroup" [editFormDetails]="editFormDetails"></mm-reports-statements-section>
</div>
